/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React from 'react';

import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import { RootState, useTivoSelector } from '../../../../core/tivo/tivo-redux-wrapper';
import { Clock } from '../../../Clock';
import { ClockTypes } from '../../../Clock/ClockTypes';

import './HeaderOneLineGuide.scss';

interface HeaderOneLineGuideProps {
    pastMode: boolean;
    hideMessage: boolean;
}

const HeaderOneLineGuide: React.FC<HeaderOneLineGuideProps> = ({
    pastMode,
    hideMessage,
}): JSX.Element => {
    const { channelsTypeIndex } = useTivoSelector(
        (state: RootState) => state.channelOptionsOverlay,
    );
    const error = useTivoSelector((state: RootState) => state.oneLineGuide.error);

    const classes = `olg-header-container ${pastMode ? 'olg-past-mode' : ''}`;
    const channelFilter = `• ${Locale.getString(channelsTypeIndex)}`;
    return (
        <div className={classes}>
            {!error && !hideMessage && (
                <span className="olg-header-message">
                    {Locale.getString(LocaleKeys.GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE)}
                </span>
            )}
            <span className="olg-filter">{channelFilter.toLowerCase()}</span>
            <Clock type={ClockTypes.OLG_CLOCK} />
        </div>
    );
};

export default HeaderOneLineGuide;
